import { useState } from "react";
import DSCard from "../../../../system-design/DSCard";
import DSCardContent from "../../../../system-design/DSCardContent";
import DSEnumSelect, {
  DSEnumSelectOption,
} from "../../../../system-design/DSEnumSelect";
import DSButton from "../../../../system-design/DSButton";
import useGetClockOnlineLogs from "./hooks/useGetClockOnlineLogs";
import DeviceOnlineTimeline from "./DeviceOnlineTimeline";
import DeviceOnlineTable from "./DeviceOnlineTable";
import DSBox from "../../../../system-design/DSBox";
import DSTypography from "../../../../system-design/DSTypography";
import { useDevice } from "../../../context/DeviceModalContext";
import DSSectionHeading from "../../../../system-design/DSSectionHeading";
import { sectionCardSx } from "../../../../system-design/sectionCardSx";

const DATE_LIMIT_OPTIONS: DSEnumSelectOption<string>[] = [
  { value: "1 DAY", label: "1 Day" },
  { value: "2 DAY", label: "2 Days" },
  { value: "7 DAY", label: "1 Week" },
  { value: "30 DAY", label: "1 Month" },
  { value: "60 DAY", label: "2 Months" },
];

const DeviceOnlineCard = () => {
  const { device } = useDevice();

  const [dateLimit, setDateLimit] = useState("1 DAY");
  const { data, error, isFetching, refetch } = useGetClockOnlineLogs(
    device.id,
    dateLimit,
    false,
  );
  return (
    <DSCard
      className="card-stats"
      sx={[
        sectionCardSx,
        {
          mb: 2,
        },
      ]}
    >
      <DSSectionHeading>Online Status</DSSectionHeading>
      <DSCardContent>
        <DSBox sx={{ display: "flex" }}>
          <DSEnumSelect
            value={dateLimit}
            options={DATE_LIMIT_OPTIONS}
            onChange={setDateLimit}
          />

          <DSButton
            sx={{ marginTop: 1, marginLeft: 1, width: 120 }}
            variant="contained"
            size="small"
            disabled={isFetching}
            onClick={() => refetch()}
          >
            {isFetching ? "Loading..." : "Load Logs"}
          </DSButton>
        </DSBox>

        {error && (
          <DSTypography variant="body2" color="error" sx={{ mt: 1 }}>
            Failed to load logs{error.message ? `: ${error.message}` : ""}
          </DSTypography>
        )}

        {data && data.length > 0 && (
          <>
            <DeviceOnlineTimeline data={data} dateLimit={dateLimit} />
            <DeviceOnlineTable data={data} />
          </>
        )}

        {data && data.length === 0 && (
          <DSTypography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            No data available
          </DSTypography>
        )}
      </DSCardContent>
    </DSCard>
  );
};

export default DeviceOnlineCard;
